/////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Tencent is pleased to support the open source community by making tgfx available.
//
//  Copyright (C) 2023 Tencent. All rights reserved.
//
//  Licensed under the BSD 3-Clause License (the "License"); you may not use this file except
//  in compliance with the License. You may obtain a copy of the License at
//
//      https://opensource.org/licenses/BSD-3-Clause
//
//  unless required by applicable law or agreed to in writing, software distributed under the
//  license is distributed on an "as is" basis, without warranties or conditions of any kind,
//  either express or implied. see the license for the specific language governing permissions
//  and limitations under the license.
//
/////////////////////////////////////////////////////////////////////////////////////////////////

export interface FrameData {
  id: number;
  data: ArrayBuffer;
  width: number;
  height: number;
}

export class ArrayBufferImage {
  public buffer: ArrayBuffer;
  public width: number;
  public height: number;
  public constructor(buffer: ArrayBuffer, width: number, height: number) {
    this.buffer = buffer;
    this.width = width;
    this.height = height;
  }

  public setFrameData(frameData: FrameData) {
    this.buffer = frameData.data;
    this.width = frameData.width;
    this.height = frameData.height;
  }
}
